import { isEqual } from '../fit-wizard/utils/searchParams';

class FitHashstate extends HTMLElement {
  static get is() { return 'fit-hashstate'; }

  constructor(props) {
    super(props);
    this.hidden = true;
  }

  connectedCallback() {
    window.addEventListener('popstate', this._boundUpdateParamsFromHash = this._updateParamsFromHash.bind(this));
    this._updateParamsFromHash();
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this._boundUpdateParamsFromHash);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'excluded-params':
        this.excludedParams = newValue;
        break;
    }
  }

  set excludedParams(excludedParams) {
    this._excludedParams = JSON.parse(excludedParams);
    this._updateParamsFromHash();
  }

  get params() {
    return this._params;
  }

  _updateParamsFromHash() {
    const url = new URL(document.location.href);
    const params = this._parseSearch(url.hash);

    if (this._excludedParams && this._excludedParams.length) {
      this._excludedParams.forEach((paramName) => {
        delete params[paramName];
      });
    }

    if (!isEqual(this.params, params)) {
      this._params = params;
      this.dispatchEvent(new CustomEvent('fit-hash-params-updated', { detail: params, bubbles: true, composed: true }));
    }
  }

  _parseSearch(search) {
    const h = {};
    if (search === undefined || search.length <= 1) {
      return h;
    }
    const q = search.slice(1).split('&');
    for (let i = 0; i < q.length; i++) {
      const key_val = q[i].split('=');
      if (key_val[1] === undefined) {
        continue;
      }
      // replace '+' (alt space) char explicitly since decode does not
      const hkey = decodeURIComponent(key_val[0]).replace(/\+/g, ' ');
      const hval = decodeURIComponent(key_val[1]).replace(/\+/g, ' ');
      if (h[hkey] === undefined) {
        h[hkey] = [];
      }
      h[hkey].push(hval);
    }
    return h;
  }
}

customElements.define(FitHashstate.is, FitHashstate);
